export const API_URL = process.env.REACT_APP_API_URL;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

export const END_POINTS = {
  //auth
  login: "/api/office/auth/office-login",
  forgotPassword: "/api/office/auth/forget-password",
  verifyOtp: "/api/office/auth/verify-otp",
  resetPassword: "/api/office/auth/rest-password",
  changePassword: "/api/adminUser/change-password",
  getProfile: "/api/adminUser/user-profile",
  updateProfile: "/api/adminUser/update-profile",
  logout: "user/logout",
  upload: "/api/adminUser/profile-picture",

  //cms
  contactSupport: "/api/office/cms/Get-contactsupport",
  legal: "/api/office/cms/Get-leagalcontent",
  faq: "/api/office/cms/faq-list",
  privacyPolicy: "/api/office/cms/Get-privacypolicy",
  addLegal: "/api/office/cms/create-legalcontent",
  addPrivacyPolicy: "/api/office/cms/create-privacypolicy",
  addContactSupport: "/api/office/cms/create-contactsupport",
  addFaq: "/api/office/cms/create-faq",
  editFaq: "/api/office/cms/edit-faq",
  deleteFaq: "/api/office/cms/delete-faq",
  interest: "/api/office/cms/interest-list",
  addInterest: "/api/office/cms/create-interest",
  deleteInterest: "/api/office/cms/delete-interest",
  getDietary: "/api/office/cms/get-dietary",
  getAboutUs: "/api/office/cms/get-aboutus",
  addAboutUs: "/api/office/cms/create-aboutus",
  getCancellation: "/api/office/cms/get-cancellationpolicy",
  addCancellation: "/api/office/cms/create-cancellationpolicy",

  //category
  category: "/api/booking/Category-list",
  addCategory: "/api/booking/create-category",
  editCategory: "/api/booking/update-category",
  deleteCategory: "/api/booking/category-delete",
  categoryStatus: "/api/booking/change-category-status",

  //user
  getUser: "/api/office/user/user-list",
  cancelMember: "/api/office/user/cancel-membership",
  approveMember: "/api/office/user/approve-membership",
  addUser: "/api/office/user/add-user",
  userDetail: "/api/office/user/Get-member-profile",
  editUser: "/api/office/user/edit-user",
  makeVip: "/api/office/user/user-vip",
  changeBio: "/api/office/user/user-bio",
  userBookingHistory: "/api/office/user/get-user-bookinghistroy",
  userTransactionHistory: "/api/office/user/get-user-transactionhistroy",
  generateLink: "/api/office/user/generate-payment-link",
  changeUserStatus: "/api/office/user/change-user-status",
  cancelSubscription: "/api/office/user/cancel-subscription",
  referHistory: "/api/office/user/referred-user-list",
  deleteUser: "/api/office/user/delete-user",
  refundSubscription: "/api/office/user/refund-subscription",

  //employee
  getEmployee: "/api/employee/employee-listing",
  addEmployee: "/api/employee/create-employee",
  employeeStatus: "/api/employee/employee-change-status",
  employeeDetails: "/api/employee/get-employeedetails",
  updateEmployee: "/api/employee/update-employee-profile",

  //expertise
  getExpertise: "/api/office/cms/get-expertise",
  addExpertise: "/api/office/cms/create-expertise",
  deleteExpertise: "/api/office/cms/delete-expertise",

  //internal process
  getInternalProcess: "/api/offermanagement/get-internalprocess",
  addInternalProcess: "/api/offermanagement/create-internalprocess",
  deleteInternalProcess: "/api/offermanagement/delete-internalprocess",
  editInternalProcess: "/api/offermanagement/edit-internalprocess",
  InternalProcessStatus: "/api/offermanagement/status-internalprocess",

  //subscription & payments
  getSubscription: "/api/officesubscription/get-subscription",
  addSubscription: "/api/officesubscription/create-subscription",
  editSubscription: "/api/officesubscription/edit-subscription",
  deleteSubscription: "/api/officesubscription/delete-subscription",
  subscriptionDetails: "/api/officesubscription/subscription-details",
  subscriptionStatus: "/api/officesubscription/change-status",
  transactions: "/api/officesubscription/get-subscription-paymentdetails",
  bookingPayments: "/api/officesubscription/Get-booking-payment-details",
  directLinkPayment: "/api/office/user/get-generate-link-payment-details",
  cancelTransactionDetails:
    "/api/officesubscription/Get-cancel-transaction-details",

  //groups&tags
  getTagGroups: "/api/offermanagement/get-grouptaglist",
  addTagGroup: "/api/offermanagement/create-grouptag",
  changeTagGroupStatus: "/api/offermanagement/changestatus-grouptag",
  deleteTagGroup: "/api/offermanagement/delete-grouptags",
  updateTagGroup: "/api/offermanagement/update-grouptag",
  getTags: "/api/offermanagement/get-tags",
  createTags: "/api/offermanagement/create-tags",
  updateTags: "/api/offermanagement/update-tags",
  changeTagStatus: "/api/offermanagement/changestatus-tags",
  deleteTags: "/api/offermanagement/delete-tags",

  //member groups
  getMemberGroups: "/api/office/cms/group-list",
  addMemberGroups: "/api/office/cms/create-group",
  deleteMemberGroup: "/api/office/cms/delete-group",
  allMembers: "/api/office/user/get-All-member",
  getMembersByGroup: "/api/office/user/get-group-member",
  addMemberToGroup: "/api/office/user/add-members-group",
  addMemberToMultipleGroups: "/api/office/user/member-add-multiplegroups",
  getUserByGroupId: "/api/office/user/GetGroupsByUserId",

  //notifications
  notifications: "/api/notification/get-notification",
  deleteMyNotifications: "/api/notification/delete-notification",
  addNotifications: "/api/notification/notification-broadcast",
  broadcastNotifications: "/api/notification/get-broadcast-message",
  deleteBroadcastNotifications: "/api/notification/broadcast-delete",
  deviceSpecificUsers: "/api/notification/get-user-device-specific",
  broadcastMembers: "/api/notification/get-broadcast-members",
  activeOffers: "/api/notification/active-offers",
  usersNotification: "/api/notification/get-users-notification",

  //offer
  createOffer: "/api/offermanagement/create-offer",
  getOffers: "/api/offermanagement/get-offer",
  multipleGroupTags: "/api/offermanagement/get-multiple-groups-tags",
  previousQuestion: "/api/offermanagement/get-previousquestion",
  uploadOfferImage: "api/offermanagement/upload-offer-image",
  getOfferById: "/api/offermanagement/get-offer",
  updateOffer: "/api/offermanagement/update-offer",
  addUserForDining: "/api/offermanagement/create-booking-dining",
  addUserForEvent: "/api/offermanagement/create-booking-event",
  offerBookingHistory: "/api/offermanagement/booking-history",
  offerStatus: "/api/offermanagement/change-offer-status",
  getCancelledOffers: "/api/offermanagement/get-cancelled-offers",
  cancelledOfferMembers: "/api/offermanagement/get-cancelled-offer-members",
  addComplimentaryBooking: "/api/offermanagement/add-complementary-booking",
  addInviteUser: "/api/offermanagement/add-invite-booking",
  userDetailByEmail: "/api/offermanagement/get-userdetails",
  bookingMembers: "/api/offermanagement/get-all-booking-members",
  cancelEvent: "/api/offermanagement/cancel-offer",
  eventRefund: "/api/offermanagement/refund-offer-api",
  cloneOffer: "/api/offermanagement/clone-offer",
  stopOfferBooking: "/api/offermanagement/stop-booking",
  addPaidUser: "/api/offermanagement/add-paid-booking",

  //butterfly effect
  getButterflyEffect: "/api/offermanagement/butterfly-effect",
  setButterflyEffectOrder: "/api/offermanagement/ordering-butterfly-effect",
  butterflyShowHide: "/api/offermanagement/manage-butterfly-showhide",
  setCategoryOrder: "/api/offermanagement/ordering-category",

  //bookings
  getBookings: "/api/booking/get-booking-list",
  allEmployees: "/api/booking/get-employee",
  assignEmployee: "/api/booking/assign-Employee",
  bookingDetail: "/api/booking/get-booking-details",
  getNotes: "/api/booking/get-notes",
  addNotes: "/api/booking/add-notes",
  cancelledBookings: "/api/booking/get-cancelled-booking",
  exceptionalGuest: "/api/booking/add-exceptional-guest",
  refundMembers: "/api/booking/get-booking-members",
  cancellationRefund: "/api/booking/cancellation-and-refund-amount",
  editBooking: "/api/booking/edit-booking",
  editHistory: "/api/booking/booking",
  refundGuest: "/api/booking/refund-booking-user",
  clearBookingCount: "/api/booking/bookingCountClear",

  //export
  exportUser: "/api/export/export-user",
  exportOffer: "/api/export/export-offer",
  exportButterflyEffect: "/api/export/export-butterfly-data",
  exportBookingPayment: "/api/export/export-booking-payment-data",
  exportUserPayment: "/api/export/export-user-payment-data",
  exportCancellation: "/api/export/export-booking-cancellation-data",
  exportLinkData: "/api/export/export-link-data",
  exportMemberReport: "/api/export/export-member-report",
  exportBookingReport: "/api/export/export-booking-report",
  exportOfferById: "/api/export/export-offerById",

  //reports
  memberReports: "/api/reports/get-members",
  bookingReports: "/api/reports/get-bookings",
  cancellationReports: "/api/reports/get-cancellation-reports",

  //sub admin
  createRole: "/api/SubAdmin/role-permission",
  getRoles: "/api/SubAdmin/get-all-roles",
  getRoleById: "/api/SubAdmin/get-role",
  roleStatus: "/api/SubAdmin/change-role-status",
  deleteRole: "/api/SubAdmin/DeleteRole",
  createSubAdmin: "/api/SubAdmin/create-subadmin",
  getSubAdmins: "/api/SubAdmin/GetAllSubAdmins",
  getSubAdminById: "/api/SubAdmin/GetSubAdminById",
  editSubAdmin: "/api/SubAdmin/EditSubAdmin",
  deleteSubAdmin: "/api/SubAdmin/DeleteSubAdmin",

  //dashoard
  getDashboard: "/api/dashboard/get-kpis",
  getTodayBookings: "/api/dashboard/get-today-bookings",
  newSignups: "/api/dashboard/new-signups",
  expiringTrials: "/api/dashboard/expiring-trials",
  topMembers: "/api/dashboard/get-top-members",
  activeMembers: "/api/dashboard/active-members",
  upcomingRenewals: "/api/dashboard/upcoming-renewal",
  memberEngagement: "/api/dashboard/member-engagement",
  popularOffers: "/api/dashboard/most-popular-bookings",
};
